(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConfirmSubscriptionController', ConfirmSubscriptionController);

    ConfirmSubscriptionController.$inject = ['LoginService', 'Auth', '$state', '$resource', '$scope', '$rootScope', '$stateParams', 'entity', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', '$timeout'];

    function ConfirmSubscriptionController(LoginService, Auth, $state, $resource, $scope, $rootScope, $stateParams, entity, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, $timeout) {
        var vm = this;

        vm.isPayed = false;
        vm.companySubscriptionStatus = entity;
        vm.showLogin = showLogin;
        vm.isSMSPAckage = false;

        $scope.$watch('vm.companySubscriptionStatus.subscriptionPackage', function (ob) {

            if (ob && vm.companySubscriptionStatus != null && vm.companySubscriptionStatus != undefined && entity.subscriptionPackage) {

                vm.companySubscriptionStatusList = [];
                vm.companySubscriptionStatusList.push(vm.companySubscriptionStatus);
                vm.isPayed = true;
                addGTagData();

                if (entity.subscriptionPackage.packageType && entity.subscriptionPackage.packageType == 'SMS') {
                    vm.isSMSPAckage = true;
                }

            }
        })


        function showLogin() {

            if (vm.isSMSPAckage) {
                gotoSMSPackages();
            } else {
                Auth.logout();
                LoginService.open(gotoSubscription);
            }
        }

        function gotoSubscription() {
            $state.go('supplierPanel.companySubscriptionStatusV2');
        }

        function gotoSMSPackages() {
            $state.go('supplierPanel.companySmsPackageStatus');
        }

        function addGTagData() {

            if (!entity.subscriptionPackage || !entity.subscriptionPackage.subscriptionType) {
                return;
            }
            if (vm.isSMSPAckage)
                return;

            try {
                //user Purchase Success
                // gtag('event', 'purchase_success', {
                //     "items": [
                //         {
                //             "id": "PL104",
                //             "name": entity.subscriptionPackage.title + "--" + entity.subscriptionPackage.durationDays + " Days",
                //             "list_name": "",
                //             "brand": "Planovin",
                //             "category": entity.subscriptionPackage.subscriptionType,
                //             "price": entity.subscriptionPackage.chargeFee
                //         }
                //     ]
                // });
                gtag('event', 'purchase', {
                    "transaction_id": entity.subscriptionPackage.id,
                    "value": entity.subscriptionPackage.chargeFee,
                    "currency": "USD",
                    "tax": 0,
                    "shipping": 0,
                    "items": [
                        {
                            "id": "PL104",
                            "name": entity.subscriptionPackage.title + "--" + entity.subscriptionPackage.durationDays + " Days",
                            "list_name": "",
                            "brand": "Planovin",
                            "category": entity.subscriptionPackage.subscriptionType,
                            "quantity": 1,
                            "price": entity.subscriptionPackage.chargeFee
                        }

                    ]
                });


            } catch (err) {
                console.log(err);
            }

        }

    }
})();
